import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* About */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_fee065bf-0317-4432-aaa9-7ab2b5910186/artifacts/366zs7sx_Bhagat-Prop-Built-WHITE-BG%20%281%29.png" 
              alt="Bhagat Prop Built" 
              className="h-16 w-auto"
            />
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm hover:text-[#B8944A] transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-[#B8944A] transition-colors">About Us</Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-[#B8944A] transition-colors">Services</Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-[#B8944A] transition-colors">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="mt-1 flex-shrink-0 text-[#B8944A]" />
                <span className="text-sm">0526/31, Sector-27, Techzone, Greater Noida, Uttar Pradesh 201312</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="flex-shrink-0 text-[#B8944A]" />
                <div className="flex flex-col gap-1">
                  <a href="tel:+919999505420" className="text-sm hover:text-[#B8944A] transition-colors">+91 99995 05420</a>
                  <a href="tel:+917838486828" className="text-sm hover:text-[#B8944A] transition-colors">+91 78384 86828</a>
                </div>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="flex-shrink-0 text-[#B8944A]" />
                <a href="mailto:bhagatpropbuilt@gmail.com" className="text-sm hover:text-[#B8944A] transition-colors">bhagatpropbuilt@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 text-center">
          <p className="text-sm">
            &copy; {new Date().getFullYear()} Bhagat Prop Built. All rights reserved.
            Made by dynomixmedia.com
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
